/** @format */

import React, { useRef } from 'react';
import { PageContainer, TableComponents } from 'components';
import { Grid } from '@mui/material';
import { columns } from '../components/ColumnsMyDealing';
import DealerService from '../services';
import { DealingProductsListDialog } from '../components';
import useCustomHook from '../hooks';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import axios from 'axios';

const MyDealingList = () => {
  const {
    openAllowedProductsDialog,
    setOpenAllowedProductsDialog,
    dealingBusinessId,
    setDealingBusinessId,
    allProductAllow,
    setAllProductAllow,
    loading, setLoading,
    size, setSize,
    page, setPage
  } = useCustomHook();
  const actionsList =
    getDynamicObjectAction([
      'listDealingPage',
      'dealingProdcutList'
    ]);
  const tableRef = useRef();
  const getDealingList = async (query) => {
    setLoading(true)
    const params = {
      offset: query ? query?.pageNumber * query?.pageSize : page * size,
      size: query ? query?.pageSize : size,
    };

    query?.filters?.forEach?.((f) => {
      params[f.column?.field] = f.value;
    });

    try {
      const data = await DealerService.getDealingList(params);
      const list = createData(data.result, {
        page: query ? query?.pageNumber : page,
        pageSize: query?.pageSize || size,
      });
      setLoading(false)
      return {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: data.count,
      };
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false)
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };
  const showAllowedProducts = (rd) => {
    setDealingBusinessId(rd.id);
    setAllProductAllow(rd.allProductAllow);
    setOpenAllowedProductsDialog(true);
  };
  const createData = (data, params) => {
    const list = data.map((item, key) => {
      const business = item?.business;

      return {
        num: params?.page * params?.pageSize + key + 1,
        name: business.name,
        id: business.id,
        numOfProducts: business.numOfProducts,
        sheba: business.sheba || '-',
        enable: item.enable ? 'فعال' : 'غیرفعال',
        allProductAllow: item.allProductAllow,
      };
    });

    return list;
  };

  const hint =
    'در این بخش می‌توانید لیست کسب‌وکارهایی که مجوز صدور فاکتور / سهم از فاکتور برای آن‌ها دارید (کارگزار آن‌ها هستید) را مشاهده کنید.';

  return (
    <PageContainer title="مجوزهای کارگزاری من" description={hint} breadcrumbs={constBreadCrumbsTitle.DEALING_LIST}>
      {actionsList['listDealingPage'] && (
        <Grid container direction="row" alignItems="center" spacing={4}>
          <Grid item xs={12}>
            <TableComponents
              data={getDealingList}
              columns={columns(showAllowedProducts, actionsList)}
              isLoading={loading}
              ref={tableRef}
              onChange={(ps) => {
                setPage(ps?.pageNumber)
                setSize(ps?.pageSize)
                return getDealingList(ps)
              }}
            />
          </Grid>
        </Grid>
      )}
      <DealingProductsListDialog
        open={openAllowedProductsDialog}
        setOpen={setOpenAllowedProductsDialog}
        dealingBusinessId={dealingBusinessId}
        allProductAllow={allProductAllow}
      />
    </PageContainer>
  );
};

export default MyDealingList;
